module.exports = __webpack_public_path__ + "img/analytical_testing_instrument.f4c5ddc9.svg";